<template>
  <div class="o_d" :class="getStatus() == 6 ? 'fail_o' : ''">
    <div class="p_f head_o" :class="getStatus() == 6 ? 'fail' : ''">
      <div class="head_out d_f ali_c">
        <div class="back cur_p t_l" :class="isBig ? 'big' : ''"><img @click="$router.go(-1)" src="../assets/img/th_back.png" alt=""></div>
        <div class="flex_1 t_a">订单详情</div>
        <div class="cancel_btn cur_p" @click.stop="cancelOrder" v-if="getStatus() == 1">
          <span>取消订单</span>
        </div>
      </div>
      <div class="d_f ali_b od_sta">
        <!--od_dsy,od_yqr,od_shz,od_ytq,od_sb-->
        <img v-if="getStatus() == 1" src="../assets/img/od_time_w.png" alt="">
        <img v-if="getStatus() == 2" src="../assets/img/od_jygb.png" alt="">
        <img v-if="getStatus() == 3" src="../assets/img/od_yqr.png" alt="">
        <img v-if="getStatus() == 4 || getStatus() == 5" src="../assets/img/od_shz.png" alt="">
        <img v-if="getStatus() == 6" src="../assets/img/od_sb.png" alt="">
        <img v-if="getStatus() == 8" src="../assets/img/od_yqr.png" alt="">
        <img v-if="getStatus() == 9" src="../assets/img/od_ytq.png" alt="">
        <div class="t_l">
          <!--待使用，已确认，退款审核中，商家已退款，退款失败-->
          <div v-if="getStatus() == 1">等待付款</div>
          <div class="sta_t" v-if="getStatus() == 1">未支付订单将在 <van-count-down :time="cutTime" format=" mm 分 ss 秒"/>后取消</div>

          <div v-if="getStatus() == 2">交易关闭</div>
          <div class="sta_t" v-if="getStatus() == 2">再逛逛，下个课程就是你兴许就是你所中意的~</div>

          <div v-if="getStatus() == 3">待使用</div>
          <div class="sta_t" v-if="getStatus() == 3">你已成功报名，欢迎您加入我们的大家庭</div>
          <!--你已成功报名亲子课堂，欢迎您加入我们的大家庭-->

          <div v-if="getStatus() == 8">已使用</div>
          <div class="sta_t" v-if="getStatus() == 8">你已使用，期待您再次加入我们的大家庭</div>

          <div v-if="getStatus() == 9 || getStatus() == 10">商家已退款</div>
          <div class="sta_t" v-if="getStatus() == 9 || getStatus() == 10">退款申请已审核通过，商家已退款预计1-3个工作日到账</div>

          <div v-if="getStatus() == 4 || getStatus() == 5">退款审核中</div>
          <div class="sta_t" v-if="getStatus() == 4 || getStatus() == 5">退款申请已受理，正在审核中，请耐心等待...</div>

          <div v-if="getStatus() == 6 || getStatus() == 7">退款失败</div>
          <div class="sta_t" v-if="getStatus() == 6 || getStatus() == 7">商家拒绝了你的退款申请</div>

          <!--带队老师将在3个工作日内与你联系，请保持电话畅通-->
          <!--商家拒绝了你的退款申请 format="DD 天 HH 时 mm 分 ss 秒"-->
        </div>
      </div>

      <div class="od_fail t_l text_over" v-if="(getStatus() == 6 || getStatus() == 7) && (orderInfo.refundInfoList && orderInfo.refundInfoList.length)">
        拒绝理由：<span>{{auditContent}}</span>
      </div>

    </div>
    <!--订单编号done-->
    <div class="or_num">
      <div class="d_f ali_c j_s mb_20" v-if="orderInfo.showStatus == 6">
        <div v-if="getStatus() == 9 || getStatus() == 10">退款金额（预计1-3个工作日到账）</div>
        <div v-else>已支付</div>
        <div>￥{{orderInfo.sellPrice ? orderInfo.sellPrice/100 : 0}}</div>
      </div>
      <div class="d_f ali_c j_s">
        <div>订单编号</div>
        <div>{{orderInfo.orderNo}}</div>
      </div>
      <div class="d_f ali_c j_s">
        <div>订单创建时间</div>
        <div>{{orderInfo.createTime}}</div>
      </div>
    </div>
    <!--商品信息done-->
    <div class="o_top_card">
      <div class="d_f tag_out">
        <div class="tag" :style="{backgroundColor : orderInfo.bgColor}">{{orderInfo.commodityTypeName}}</div>
        <span class="flex_1">{{orderInfo.commodityName}}</span>
      </div>
      <div class="pri_out d_f ali_b j_s">
        <span><span>{{orderInfo.startTime.split(' ')[0]}}</span> — <span>{{orderInfo.endTime.split(' ')[0]}}</span><span v-if="orderInfo.duration"> | 共{{orderInfo.duration}}</span>
          <span v-for="(itm,idx) in orderInfo.tagList" :key="idx" v-if="itm">{{' | '+itm}}</span>
        </span>
        <div>
          <div class="price_sub" v-if="orderInfo.orderType == 1">销售数量：<span>{{orderInfo.sellNum}}</span>个</div>
          <div class="price_sub" v-else>报名人数：<span>{{orderInfo.sellNum}}</span>人</div>
        </div>
      </div>
      <div class="item_d">
        <div class="d_f ali_c j_s">
          <span>课程单价</span>
          <span>￥<span>{{orderInfo.sellPrice ? orderInfo.sellPrice/100/orderInfo.sellNum : 0}}</span></span>
        </div>
        <div class="d_f ali_c j_s">
          <span>数量</span>
          <span>X <span>{{orderInfo.sellNum}}</span></span>
        </div>
        <div class="d_f ali_c j_s">
          <span>应付金额</span>
          <span>￥<span>{{orderInfo.sellPrice ? orderInfo.sellPrice/100 : 0}}</span></span>
        </div>
      </div>
    </div>
    <!--预订人信息done-->
    <div class="order_per">
      <div class="op_title d_f ali_c">
        <span>预订人信息</span>
      </div>
      <div class="items d_f ali_c">
        <span>中文名字</span>
        <span class="input">{{orderInfo.linkmenName}}</span>
      </div>
      <div class="items d_f ali_c b_n">
        <span>电话号码</span>
        <span class="input">{{orderInfo.telephone}}</span>
      </div>
    </div>
    <!--已报名学生非亲子类  已完成的状态才能申请退款-->
    <div class="od_back_e od_reason" v-if="orderInfo.orderType == 0 && ((orderInfo.showStatus == 6 && isReFei) || (getStatus() > 3 && getStatus() != 8))">
    <!--<div class="od_back_e od_reason">-->
      <div class="or_title d_f ali_c j_s">
        <span>已报名学生</span>
        <div class="d_f ali_c" @click="checkAll" v-if="isReFei && (getStatus() == 3 ||getStatus() == 5 || getStatus() == 7 || getStatus() == 10)">
          <img src="../assets/img/or_check.png" alt="" v-if="acAll">
          <img src="../assets/img/or_un_check.png" alt="" v-else>
          <span>全选</span>
        </div>
      </div>
      <van-checkbox-group v-model="checked">
        <div class="ob_item d_f" v-for="(item,index) in orderInfo.detailList" :key="index">
          <van-checkbox
            :name="item.orderDetailId"
            shape="square"
            checked-color="#24BDDD"
            icon-size="16px"
            v-if="isReFei && (getStatus() == 3 || getStatus() == 5 || getStatus() == 7 || getStatus() == 10)"
            :disabled="item.showDetailStatus == 1 || item.showDetailStatus == 2 || item.showDetailStatus == 3|| item.showDetailStatus == 5|| item.showDetailStatus == 6|| item.showDetailStatus == 7|| item.showDetailStatus == 8"></van-checkbox>
          <div class="flex_1 d_f ali_c obi_d" :class="item.showDetailStatus == 1 || item.showDetailStatus == 2 || item.showDetailStatus == 3|| item.showDetailStatus == 5|| item.showDetailStatus == 6 ? 'dis' : ''">
            <div class="f_w flex_1 t_a">{{item.applicantName}}</div>
            <div class="name ali_c d_f j_c">
              <div class="name_bb">
                <div>{{item.schoolName}}</div>
                <div><span>{{item.schoolGrade}}</span>年级 <span>{{item.schoolClass}}</span>班</div>
                <div>{{item.cardNo}}</div>
              </div>

            </div>
            <!--1	未支付 2	已取消 3	待支付 4	未使用 5	已使用 6	退款中 7	已退款-->
            <div class="pri flex_1 t_a">
              <div>￥<span>{{item.sellPrice ? item.sellPrice/100 : 0}}</span></div>
              <div class="red_t" v-if="item.showDetailStatus == 8">未退款成功</div>
              <div class="green_t" v-if="item.showDetailStatus == 7">已退款</div>
              <div class="orange_t" v-if="item.showDetailStatus == 6">退款审核中</div>
            </div>
          </div>
        </div>
      </van-checkbox-group>
    </div>
    <!--已报名学生亲子类  已完成的状态才能申请退款-->
    <div class="od_back_e od_reason" v-if="orderInfo.showStatus == 6 && orderInfo.orderType == 1 && (getStatus() > 3 && getStatus() != 8)">
      <div class="or_title d_f ali_c j_s">
        <span>退款商品</span>
      </div>
      <div class="ob_item d_f">
        <div class="d_f ali_c obi_d qz">
          <div class="qz_name">
            <div class="flex_1 d_f ali_c " v-for="(item,index) in orderInfo.applicantList" :key="index">
              <div class="f_w flex_1 t_a">{{item.applicantName}}</div>
              <div class="name">
                {{item.cardNo}}
              </div>
            </div>
          </div>
          <div class="pri t_a flex_1">
            <div>￥{{orderInfo.sellPrice ? orderInfo.sellPrice/100 : 0}}</div>
            <div class="red_t" v-if="orderInfo.applicantList[0].showDetailStatus == 8">未退款成功</div>
            <div class="green_t" v-if="orderInfo.applicantList[0].showDetailStatus == 7">已退款</div>
            <div class="orange_t" v-if="orderInfo.applicantList[0].showDetailStatus == 6">退款审核中</div>
          </div>
        </div>
      </div>
    </div>
    <!--报名人信息亲子类done-->
    <div class="per_info" v-if="orderInfo.orderType == 1 && (getStatus() < 4 || getStatus() == 8)">
      <div class="per_top d_f ali_b j_s">
        <div class="ti">报名人信息</div>
      </div>
      <div>
        <div class="per_item d_f ali_c text_out" v-for="(item,index) in orderInfo.applicantList" :key="index">
          <div class="name">{{item.applicantType == 1 ? '学生' : '家长'}}</div>
          <div class="flex_1 text">
            <div class="bb d_f ali_c j_s">
              <span>{{item.applicantName}}</span>
            </div>
            <div class="d_f ali_c j_s">
              <span>{{item.cardNo}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--报名人信息非亲子类done-->
    <div class="per_info"  v-if="orderInfo.orderType == 0 && !isReFei && (getStatus() < 4 || getStatus() == 8)">
      <div class="per_top d_f ali_b j_s">
        <div class="ti">学生报名信息</div>
      </div>
      <div>
        <div class="per_item d_f ali_c text_out" v-for="(item,index) in orderInfo.detailList" :key="index">
          <div class="name">{{item.applicantName}}</div>
          <div class="flex_1 text no_blue">
            <div class="bb d_f ali_c" v-if="item.schoolName">
              <span>{{item.schoolName}}</span>·<span><span>{{item.schoolGrade}}</span>年级<span>{{item.schoolClass}}</span>班</span>
            </div>
            <div class="d_f ali_c j_s">
              <span>{{item.cardNo}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--支付方式-->
    <div class="per_pay" v-if="getStatus() == 1">
      <div class="p_title">支付方式</div>
      <div class="d_f ali_c">
        <img src="../assets/img/wechat.png" alt="" class="we">
        <span class="flex_1">微信支付</span>
        <img src="../assets/img/pay_check.png" alt="">
      </div>
    </div>
    <!--退款原因-->
    <div class="od_reason" v-if="isReFei &&( getStatus() == 3 || getStatus() == 5 || getStatus() == 7 || getStatus() == 10)">
      <div class="or_title">退款原因</div>
      <div>
        <div class="or_item d_f ali_c j_s" v-for="(item,index) in reasonArr" :key="index" @click="acReason = index">
          <span>{{item}}</span>
          <img src="../assets/img/or_check.png" alt="" v-if="acReason == index">
          <img src="../assets/img/or_un_check.png" alt="" v-else>
        </div>
      </div>
      <textarea placeholder="请输入退款原因" v-model="reReason"></textarea>
    </div>
    <!--支付按钮-->
    <div class="bottom_btn p_f" v-if="getStatus() == 1" @click="pay">
      <div class="price flex_1">
        ￥<span>{{orderInfo.sellPrice ? orderInfo.sellPrice/100 : 0}}</span>
      </div>
      <div class="btn">确认支付</div>
    </div>
    <!--返回研学商城按钮-->
    <div class="bottom_big_btn" @click="$router.push('/Mall')" v-if="getStatus() == 4 || getStatus() == 6 || getStatus() == 8 || getStatus() == 9">返回研学商城</div>

    <!--这儿两个按钮是还没退过款展示的-->
    <!--申请退款按钮(亲子类退款原因是个弹窗)-->
    <div class="bottom_big_btn" @click="showBackPopQz" v-if="getStatus() == 3 && orderInfo.orderType == 1">申请退款</div>
    <!--申请退款按钮(非亲子类退款原因是个弹窗)-->
    <div class="bottom_big_btn" @click="showBackPop" v-if="(getStatus() == 3 || getStatus() == 5 || getStatus() == 7 || getStatus() == 10) && orderInfo.orderType == 0 && !isReFei">申请退款</div>

    <!--返回商城、申请退款按钮(非亲子类)-->
    <div class="bottom_two bottom_big_btn" v-if="orderInfo.orderType == 0 && ((getStatus() == 3 || getStatus() == 5 || getStatus() == 7 || getStatus() == 10) && isReFei)">
      <div class="flex_1 white" @click="$router.push('/Mall')">返回商城</div>
      <div class="flex_1" @click="refundApply">申请退款</div>
    </div>

    <!--删除订单-->
    <div class="bottom_big_btn t_r" v-if="getStatus() == 2" @click="deleteOrder">
      <div class="t_a d_i delete_btn">删除订单</div>
    </div>
    <!--返回商城、撤销申请按钮(李思慧要求撤销申请功能不要了)-->
    <!--<div class="bottom_two bottom_big_btn" v-if="false">
      <div class="flex_1 white" @click="$router.push('/Mall')">返回商城</div>
      <div class="flex_1">撤销申请</div>
    </div>-->

    <!--亲子类申请退款弹窗done-->
    <van-overlay :show="isShowQzBack">
      <div class="od_wrapper d_f ali_c j_c" @click.stop>
        <div class="od_inner">
          <div class="odi_t d_f ali_c" @click="isShowQzBack = false">
            <van-icon name="cross" />
            <span class="flex_1 t_a">退款原因</span>
          </div>
          <div class="ori_out">
            <div>
              <div class="or_item d_f ali_c j_s" v-for="(item,index) in reasonArr" :key="index" @click="acReason = index">
                <span>{{item}}</span>
                <img src="../assets/img/or_check.png" alt="" v-if="acReason == index">
                <img src="../assets/img/or_un_check.png" alt="" v-else>
              </div>
            </div>

            <textarea placeholder="请输入退款原因" v-model="reReason"></textarea>
          </div>
          <div class="back_btn t_a" @click="refundApply">提交申请</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  export default {
    name: "OrderDetail",
    data() {
      return {
        isBig:true,
        checked:[],
        reasonArr:[
          '家中有事不能参与',
          '行程有变动',
          '学校补课与活动时间冲突',
          '活动形式描述不符',
          '其他原因',
        ],
        acReason:null,
        reReason:'',
        acAll:false,
        isShowQzBack:false,
        isReFei:false,
        orderInfo:{startTime:'',endTime:''},
        orderId:this.$route.query.orderId,
        cutTime:0,
        auditContent:'',
        interVal:null,
      }
    },
    created(){
      this.orderQuery();
    },
    onBeforeRouteLeave(){
      window.clearInterval(this.interVal);
      this.interVal = null;
    },
    methods: {
      //支付
      pay(){
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '支付中'
        });
        this.$api.payOrder({orderId:this.orderId,payChannel:'1',totalPrice:this.sellPrice}).then(res => {
          let info = this.jsonInfo(res.data.formData);
          this.payWechat(info)
        }).catch(err => {
          Toast(err.message);
          window.clearInterval(this.interVal);
          this.interVal = null;
        });

      },
      getOrderStatus(){
        this.$api.orderInfoQuery({orderId:this.orderId}).then(res => {
          if(res.data.showStatus == 6){
            let totalPrice = this.sellPrice ?　this.sellPrice/100 : 0;
            window.clearInterval(this.interVal);
            this.interVal = null;
            this.$router.push('/PaySuccess?totalPrice='+totalPrice+'&orderId='+this.orderId)
          }
        })

      },
      payWechat(info){
        let _t = this;
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        }else{
          onBridgeReady();
        }
        function onBridgeReady(){
          _t.interVal = setInterval(function () {
            _t.getOrderStatus()
          },1000);
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', info,
            function(res){
              _t.$toast.clear();
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
                setTimeout(function () {
                  window.clearInterval(_t.interVal);
                  clearInterval(_t.interVal);
                  _t.interVal = null;
                },10000)
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              }
            });
        }
      },
      jsonInfo(c){
        let jsonData={};
        c=c.replace("{","").replace("}","");
        c=c.split(',');
        for(let i=0;i<c.length;i++){
          if(c[i].split('=').length === 2){
            jsonData[(c[i].split('=')[0]).replace(/\s+/g,"")]=(c[i].split('=')[1]).replace(/\s+/g,"")
          }else{
            let str = '';
            for(let j = 1;j<c[i].split('=').length;j++){
              str += (c[i].split('=')[j]).replace(/\s+/g,"")+'=';
            }
            jsonData[(c[i].split('=')[0]).replace(/\s+/g,"")]=(str.substring(0,str.length-1))
          }
        }
        return jsonData
      },
      //删除订单
      deleteOrder(){
        this.$dialog.confirm({
          message: '确定删除订单？',
          confirmButtonText:'确定',
          confirmButtonColor:'#24BDDD',
          cancelButtonText:'我再想想',
        })
          .then(() => {
            this.$api.delOrder({orderId:this.orderId}).then(res => {
              this.$toast('操作成功');
              setTimeout(() => {
                this.$router.go(-1)
              },1000)
            })
          })
          .catch(() => {
            // on cancel
          });

      },
      unique(arr){
        return arr.reduce((prev,cur) => prev.includes(cur) ? prev : [...prev,cur],[]);
      },
      refundApply(){
        let detailList = [];
        if(this.orderInfo.orderType == 1){//亲子类退整单，直接赋值
          detailList.push(this.orderInfo.applicantList[0].orderDetailId)
        }else{
          this.checked.map(item => {
            detailList.push(item)
          })
        }
        let send = {
          orderId:this.orderId,
          refundReason:this.reReason ? this.reReason : this.reasonArr[this.acReason],
          detailList:this.unique(detailList),
        };
        if(!send.detailList.length) return this.$toast('请选择退款人');
        if(!send.refundReason) return this.$toast('请选择退款原因');
        this.$api.refundApply(send).then(res => {
          this.$toast('操作成功');
          this.checked = [];
          this.acReason = null;
          this.reReason = '';
          this.isShowQzBack = false;
          this.isReFei = false;
          this.orderQuery()
        })
      },
      //申请退款亲子
      showBackPopQz(){
        this.$dialog.confirm({
          message: '确定申请退款？',
          confirmButtonText:'确定',
          confirmButtonColor:'#24BDDD',
          cancelButtonText:'我再想想',
        })
          .then(() => {
            this.$dialog.close();
            this.isShowQzBack = true
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      },
      //申请退款
      showBackPop(){
        this.$dialog.confirm({
          message: '确定申请退款？',
          confirmButtonText:'确定',
          confirmButtonColor:'#24BDDD',
          cancelButtonText:'我再想想',
        })
          .then(() => {
            this.$dialog.close();
            this.isReFei = true;
          })
          .catch(() => {
            // on cancel
          });
      },
      getStatus(){
        //订单状态 0全部、1未支付、2已取消、3待支付、6已完成
        //订单明细状态 <!--1	未支付 2	已取消 3	待支付 4	未使用 5	已使用 6	退款中 7	已退款-->
        let status = 0;
        // 1待支付 2已取消 3待使用 4退款中 5退款中且有可退款的 6退款失败 7退款失败且有可退款的 8已使用 9已退款 10已退款且有可退款的
        if(this.orderInfo.showStatus == 1 || this.orderInfo.showStatus == 3){
          status = 1
        }
        if(this.orderInfo.showStatus == 2){
          status = 2
        }
        if(this.orderInfo.showStatus == 6){
          // 待使用
          let isRefund = false;
          let list = this.orderInfo.orderType == 1 ? JSON.parse(JSON.stringify(this.orderInfo.applicantList)) : JSON.parse(JSON.stringify(this.orderInfo.detailList));
          list.map(item => {
            if(item.showDetailStatus == 4){
              isRefund = true;
            }
            if(item.showDetailStatus == 7){
              status = 9;
            }
            if(item.showDetailStatus == 6){
              status = 4;
            }
            if(item.showDetailStatus == 8){
              status = 6;
            }
            if(item.showDetailStatus == 5){
              status = 8;
            }
          });
          if(isRefund){
            if(status == 4){
              status = 5
            }else if(status == 6){
              status = 7
            }else if(status == 9){
              status = 10
            }else{
              status = 3
            }
          }else{
            if(status ==  9){
              status = 9
            }
          }

        }
        return status

      },
      //非亲子全选
      checkAll(){
        if(!this.acAll){
          //订单状态 0全部、2已取消、3待支付、6已完成
          //订单明细状态 <!--1	未支付 2	已取消 3	待支付 4	未使用 5	已使用 6	退款中 7	已退款-->
          this.orderInfo.detailList.map(item => {
            if(item.showDetailStatus == 4){
              this.checked.push(item.orderDetailId)
            }
          });
          this.acAll = true;
        }else{
          this.checked = [];
          this.acAll = false;
        }
      },
      //取消订单
      cancelOrder(row){
        this.$dialog.confirm({
          message: '是否取消该订单',
          confirmButtonColor:'#24BDDD',
        }).then(() => {
          this.$api.cancelOrder({orderId:this.orderId}).then(res => {
            this.$toast('操作成功');
            this.orderQuery();
          })
        })
      },
      //查询订单详情
      orderQuery(){
        this.$api.orderQuery({orderId:this.orderId}).then(res => {
          this.orderInfo = res.data;
          if(this.orderInfo.detailList){
            this.orderInfo.detailList.map(item => {
              item.isCheck = false;
            })
          }

          if(this.orderInfo.refundInfoList){
            this.orderInfo.refundInfoList.map(item => {
              if(item.auditContent){
                this.auditContent = item.auditContent
              }
            })
          }
          //计算倒计时
          let now = new Date().getTime();
          let order = new Date(this.$renderTime(this.orderInfo.createTime)).getTime();
          if((order + 15 * 60 * 1000)>now){
            this.cutTime = (order + 15 * 60 * 1000) - now;
          }else{
            this.cutTime = 0;
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .no_blue span{
    color: #333!important;
  }
  .name_bb{
    padding: 9px 0 9px 0;
    >div{
      border-bottom: 1px solid #C0C0C0;
      line-height: 26px;
      padding: 0 18px 0 23px;
      &:last-child{
        border-bottom: none;
      }
    }
  }
  .van-count-down{
    color: white;
    display: inline;
  }
  .od_back_e .ob_item .obi_d{
    &.qz{
      .qz_name{
        >.flex_1{
          .t_a{
            padding: 0 17px;
          }
          .name{
            padding: 9px 50px 9px 32px;
            line-height: 34px;
            width: 213px;
            box-sizing: border-box;
          }
          border-bottom: 1px solid #C0C0C0;
          &:last-child{
            border-bottom: none;
          }
        }
      }
      margin-left: 0;
      width: 100%;
      height: auto;
    }
  }
  .od_wrapper{
    .od_inner{
      .back_btn{
        height: 51px;
        background: #24BDDD;
        font-size: 18px;
        line-height: 51px;
        font-weight: 500;
        color: #FFFFFF;
      }
      .ori_out{
        textarea{
          height: 100px;
          margin-top: 16px;
        }
        .or_item{
          img{
            height: 16px;
            width: 16px;
          }
          font-size: 14px;
          padding-top: 0;
          margin-bottom: 25px;
          &:last-child{
            margin-bottom: 0;
          }
        }
        padding: 21px 22px;
      }
      .odi_t{
        padding: 0 37px 0 22px;
        font-size: 16px;
        font-weight: 500;
        color: #3E3E3E;
        height: 57px;
        border-bottom: 1px solid #D0D0D0;
      }
      overflow: hidden;
      width: 350px;
      background: #FFFFFF;
      border-radius: 5px;
    }
    width: 100%;
    height: 100%;
  }
  .od_fail{
    color: #FF5A00;
    padding: 0 14px;
    line-height: 40px;
    height: 40px;
    background: #FFF0E6;
    border: 1px solid #FC5900;
    border-radius: 4px;
    margin: 0 13px 21px 13px;
  }
  textarea{
    height: 84px;
    border: 1px solid #C0C0C0;
    width: 100%;
    outline: none;
    border-radius: 4px;
    resize: none;
    padding: 12px 11px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 500;
    color: #333333;
    &::placeholder{
      color: #DDDDDD;
    }
  }
  .od_back_e{
    padding-bottom: 27px!important;
    .ob_item{
      .van-checkbox{
        margin-right: 22px;
      }
      .obi_d{
        &.dis{
          background: #F3F3F3;
          color: #CCCCCC;
        }
        .pri{
          font-size: 12px;
        }
        .name{
          /*>div{
            margin-bottom: 5px;
          }*/
          /*line-height: 52px;*/
          /*padding: 9px 18px 9px 23px;*/
          box-sizing: border-box;
          height: 100%;
          border: 1px solid #C0C0C0;;
          border-top: none;
          border-bottom: none;
        }
        font-size: 13px;
        font-weight: 500;
        color: #3E3E3E;
        height: 72px;
        border: 1px solid #C0C0C0;
        border-radius: 5px;
      }
      margin-top: 12px;
    }
  }
  .od_reason{
    &.od_back_e{
      margin-bottom: 4px;
    }
    .or_title{
      .ali_c{
        img{
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
        font-size: 12px;
        font-weight: 500;
        color: #3E3E3E;
      }
      margin-bottom: 9px;
      font-size: 16px;
      font-weight: bold;
      color: #3E3E3E;
    }
    margin-bottom: 20px;
    padding: 18px 13px 14px;
  }
  .or_item{
    img{
      height: 14px;
      width: 15px;
      cursor: pointer;
    }
    font-size: 13px;
    font-weight: 500;
    color: #3E3E3E;
    padding-top: 9px;
    margin-bottom: 9px;
    &:last-child{
      margin-bottom: 18px;
    }
  }
  .per_pay{
    margin-bottom: 15px;
  }
  .o_d{
    &.fail_o{
      padding-top: 197px;
    }
    >div{
      background-color: white;
    }
    background-color: #f5f5f5;
    height: 100vh;
    padding: 135px 0 45px 0;
    overflow-x: auto;
    box-sizing: border-box;
  }
  .head_o{
    &.fail{
      height: 197px;
    }
    .od_sta{
      .sta_t{
        font-size: 13px;
        margin-top: 13px;
      }
      img{
        height: 20px;
        width: 20px;
        margin-right: 9px;
        position: relative;
        top: 2px;
      }
      line-height: 1;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      padding: 0 13px 20px;
    }
    background: url("../assets/img/od_bg.png") no-repeat;
    background-size: 100% 100%;
    border-color: unset;
    height: 135px;
  }
  .head_out{
    padding: 0 13px;
    margin-bottom: 15px;
    .back.big,.cancel_btn{
      width: 60px;
    }
  }

</style>
